export default "__VITE_ASSET__UYFy2n7I__"